module.exports = __webpack_public_path__ + "media/images/sports_icons/roller-skating-403839e89f792d60a4e6d2f3e4312138.png";